import React, { PureComponent, Fragment } from 'react';
import { object } from 'prop-types';
import { UncontrolledPopover, PopoverHeader, PopoverBody, UncontrolledTooltip } from 'reactstrap';
import { currencyToSign } from '../../../../utils/utils';
import { FMessage } from '../../../../hoc/IntlComponents';

class PixelShortItem extends PureComponent {
  static propTypes = {
    pixel: object,
  };

  static defaultProps = {
    pixel: {},
  };

  getRate = (rate = {}) => {
    return Object.keys(rate).map(currency => {
      const [min, max] = rate[currency];

      return (
        min === max && (
          <Fragment key={currency}>
            {min}
            &nbsp;
            {currencyToSign(currency)}
          </Fragment>
        )
      );
      // : (
      //   <Fragment key={currency}>
      //     {min}
      //     &nbsp;&ndash; {max}
      //     &nbsp;
      //   {currencyToSign(currency)}
      //   </Fragment>
      // );
    });
  };

  renderPixel = () => {
    const { pixel } = this.props;

    const rendered = Object.keys(pixel).map(group => (
      <Fragment key={group}>
        <span className="pixel-title">{group}</span>
        {/* <span className="pixel-reward">{this.getRate(pixel[group])}</span> */}
      </Fragment>
    ));

    return rendered[0];
  };

  renderCurrencySign = currency => (currencyToSign(currency) ? currencyToSign(currency) : currency);

  renderGoalsTable = () => {
    const { pixels, geo, countries } = this.props;

    const countriesList = [
      ...countries,
      { id: 'KG', title: 'Киргизия' },
      { id: 'MD', title: 'Молдавия' },
    ];

    const countriesTitleList = pixels.map((pixel, index) => {
      const item = countriesList.find(
        country => country.title === pixel.title || pixel.title.includes(country.title),
      );
      if (item) {
        const { id } = item;
        return { ...pixel, countryID: id };
      } else {
        return { ...pixel, countryID: 'страна не найдена' };
      }
    });

    return (
      geo.countrys &&
      geo.countrys.map(country => {
        const pixel = countriesTitleList.find(({ countryID }) => countryID === country);
        const geoSign =
          geo.prices[country] && this.renderCurrencySign(geo.prices[country].currency);
        const pixelSign = pixel && this.renderCurrencySign(pixel.currency);

        return (
          <li key={country} className="pixel-short-item offer-prices-table-row">
            <span className={`flag-icon flag-icon-${country.toLowerCase()}`}></span>
            <span
              id={`${pixel ? `pixel-popover-${pixel.id}` : ''}`}
              className="offer-prices-table-item offer-prices-table-item-pixel"
            >
              {pixel && pixel.summ}&nbsp;{pixel && pixelSign}
            </span>
            {pixel && (
              // <UncontrolledPopover
              //   delay={{ show: 0.1, hide: 0.1 }}
              //   className="pixel-popover"
              //   trigger="legacy"
              //   placement="bottom"
              //   target={`pixel-popover-${pixel.id}`}
              // >
              //   <PopoverBody>
              //     <FMessage id="offers.table.pixel.price" />
              //   </PopoverBody>
              // </UncontrolledPopover>
              <UncontrolledTooltip
                trigger="legacy"
                target={`pixel-popover-${pixel.id}`}
                placement="bottom"
              >
                <FMessage id="offers.table.pixel.price" />
              </UncontrolledTooltip>
            )}
            <span
              id={`${pixel ? `geo-popover-${pixel.id}` : ''}`}
              className="offer-prices-table-item offer-prices-table-item-geo"
            >
              {geo.prices[country] && geo.prices[country].price}&nbsp;{geoSign}
            </span>
            {pixel && (
              // <UncontrolledPopover
              //   delay={{ show: 0.1, hide: 0.1 }}
              //   className="geo-popover"
              //   trigger="legacy"
              //   placement="bottom"
              //   target={`geo-popover-${pixel.id}`}
              // >
              //   <PopoverBody>
              //     <FMessage id="offers.table.good.price" />
              //   </PopoverBody>
              // </UncontrolledPopover>
              <UncontrolledTooltip
                trigger="legacy"
                target={`geo-popover-${pixel.id}`}
                placement="bottom"
              >
                <FMessage id="offers.table.good.price" />
              </UncontrolledTooltip>
            )}
          </li>
        );
      })
    );
  };

  render() {
    return (
      <ul className="pixel-groups-list list-unstyled">
        <li className="pixel-short-item pixel-short-item-title">{this.renderPixel()}</li>
        {this.renderGoalsTable()}
      </ul>
    );
  }
}

export default PixelShortItem;
